import React, { useReducer } from "react";

import ReducerContext from "./ReducerContext";

// eslint-disable-next-line react/prop-types
const ReducerContextProvider = ({ children, initialData, reducer }) => {
  const [state, dispatch] = useReducer(reducer, initialData, reducer);

  return (
    <ReducerContext.Provider value={{ state, dispatch }}>
      {children}
    </ReducerContext.Provider>
  );
};

export default ReducerContextProvider;
